<template lang="pug">
  .sidebar-header
    div
      span.sidebar-header-logo 云抄表平台
      .sidebar-header-controls
        button.sidebar-slide-toggle.btn.btn-link(
          :class='{"active": systemMenuShow}',
          @click="toggleSystemMenu"
        )
          i.iconfont.icon-systems
        button.sidebar-menu-toggle.d-lg-inline.d-none.btn.btn-link(@click="toggleMenu")
          i.iconfont(:class="[{'icon-pin':!menuActive},{'icon-pin1':menuActive}]")
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'Header',
  props: {
    systemMenuShow: Boolean,
    menuActive: Boolean
  },
  methods: {
    ...mapMutations([
      'toggleMenu'
    ]),
    toggleSystemMenu () {
      this.$emit('toggleSystemMenu')
    }
  }
}
</script>

<style lang="sass" scoped>
.sidebar-header
  color: #ccc
  padding: 0 0 0 15px
  .sidebar-header-logo
    font-size: 20px
    font-weight: normal
  .sidebar-header-controls
    float: right
    text-align: right
  .sidebar-slide-toggle,.sidebar-menu-toggle
    width: 20px
    margin-right: 10px
    padding: 0
    font-size: 16px
    color: #999
    &:hover, &:focus
      color: #ccc
  .sidebar-slide-toggle
    .iconfont
      font-size: 20px
  .sidebar-menu-toggle
    line-height: 22px
    .iconfont
      padding-top: 2px
      font-size: 22px
      font-weight: bold
@media (min-width:300px)
.sidebar-header
  .sidebar-header-logo
    font-size: 15px
</style>



// WEBPACK FOOTER //
// Header.vue?5a6cf3bd